<div class="list-group list-group-striped border-rad-all-12 card-shadow">
  <div class="list-group-item">
    <div class="row">
      <h5 class="col-lg-11">
        {{ 'tkey;admin.proxy_server_management.proxy_feature_settings.number_assignment_check.title.zpc' | translate }}
      </h5>
      <div class="d-flex justify-content-end col-lg-1">
        <ziro-checkbox [fieldId]="'teamsPhoneNumberAssignmentCheckEnabled'"></ziro-checkbox>
      </div>
    </div>
    <p
      [ngClass]="{ 'mb-0': !dialPlanSyncToggleEnabled }"
      [innerHTML]="
        'tkey;admin.proxy_server_management.proxy_feature_settings.number_assignment_check.description.zpc' | escapeHtml
      "
    ></p>
    <div [hidden]="!dialPlanSyncToggleEnabled">
      <ziro-radio [fieldId]="'teamsPhoneNumberAssignmentMatchType'"></ziro-radio>
      <div [hidden]="!lastDigitsMatchEnabled">
        <div class="alert alert-warning d-flex justify-content-between">
          <span>
            <i class="{{ ziroIcons.WARNING_TRIANGLE }} me-1"></i>
            <strong
              data-automation="proxy-feature-settings-end-match-warning"
              [innerHTML]="
                'tkey;admin.proxy_server_management.proxy_feature_settings.number_assignment_check.end_match_warning_banner.text'
                  | escapeHtml
              "
            ></strong>
          </span>
        </div>
        <ziro-text [fieldId]="'teamsPhoneNumberAssignmentLastDigitsMatch'"></ziro-text>
      </div>
    </div>
  </div>
</div>
